var _defs, _path, _polygon, _rect, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSanPavicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.22 284.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b84445;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0v284.92h208.22V0H0ZM192.88,269.03H15.49V15.98h177.39v253.06Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.41 65.74 157.09 118.42 177 98.51 104.48 25.99 104.41 26.06 104.35 25.99 31.83 98.51 51.74 118.42 104.41 65.74"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.89,
    y: 126.68,
    width: 107.47,
    height: 27.67
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.54 257.56 105.51 200.59 162.48 257.56 182.04 237.99 133.74 189.69 179.67 189.69 179.67 162.02 106.07 162.02 106.05 162 106.03 162.02 104.99 162.02 104.97 162 104.95 162.02 31.35 162.02 31.35 189.69 77.28 189.69 28.98 237.99 48.54 257.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanPavicon);
export default __webpack_public_path__ + "static/media/SanPavicon.6776a9007cab7162e8e121592a0443e6.svg";
export { ForwardRef as ReactComponent };